<template>
  <section class="what-we-do">
    <div class="container">
      <div class="heading">
        <h2 class="title-subhead text-center-xs">Was kann ELSAZEIT?</h2>
      </div>
      <div class="inner-hold">
        <div class="image-hold">
          <img
            src="@/../public/img/img02.jpg"
            alt="image description"
            width="1065"
            height="579">
        </div>
        <div class="content">
          <ul class="in-page-lists">
            <li>
              <h3 class="list-title">Einmaliges Anlegen</h3>
              <div class="text">
                <p>Mitarbeiter werden mit ihren Stammdaten angelegt und es muss keine permanete Eingabe von Stunden erfolgen</p>
              </div>
            </li>
            <li>
              <h3 class="list-title">Überall verfügbar</h3>
              <div class="text">
                <p>Sie müssen keine Software installieren und können das Programm von überall nutzen. </p>
              </div>
            </li>
            <li>
              <h3 class="list-title">Gesetzeskonform</h3>
              <div class="text">
                <p>Stundenberechnung auch rückwirkend</p>
              </div>
            </li>
            <li>
              <h3 class="list-title">Expressseite</h3>
              <div class="text">
                <p>Schnelles Anlegen von Mitarbeitern und schnelles Auswerten von Vorschlägen</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeWhatWeDo'
}
</script>
